import { render, staticRenderFns } from "./ConsultantList.vue?vue&type=template&id=3bfdc6c4&scoped=true&lang=html&"
import script from "./ConsultantList.vue?vue&type=script&lang=js&"
export * from "./ConsultantList.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantList.vue?vue&type=style&index=0&id=3bfdc6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdc6c4",
  null
  
)

component.options.__file = "ConsultantList.vue"
export default component.exports